"use strict";

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject7() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        text-align: right;\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    top: 31px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    top: 39px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  margin-top: 4px;\n  width: ", ";\n  color: ", ";\n  min-width: 205px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputVariants = exports.helperTextDanger = exports.helperTextWarning = exports.helperTextCompact = exports.helperTextComfortable = exports.helperTextBase = void 0;

var _stylitas = require("@creditas/stylitas");

var helperTextBase = function helperTextBase(_ref) {
  var theme = _ref.theme,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '280px' : _ref$width;
  return (0, _stylitas.css)(_templateObject(), _stylitas.utilities.typography.supportForm(theme), width, _stylitas.utilities.palette.color(theme, 'neutral06'));
};

exports.helperTextBase = helperTextBase;

var helperTextComfortable = function helperTextComfortable(_ref2) {
  var size = _ref2.size;
  return size === 'comfortable' && (0, _stylitas.css)(_templateObject2());
};

exports.helperTextComfortable = helperTextComfortable;

var helperTextCompact = function helperTextCompact(_ref3) {
  var size = _ref3.size;
  return size === 'compact' && (0, _stylitas.css)(_templateObject3());
};

exports.helperTextCompact = helperTextCompact;

var helperTextWarning = function helperTextWarning(_ref4) {
  var theme = _ref4.theme,
      variant = _ref4.variant,
      disabled = _ref4.disabled;
  return variant === 'warning' && !disabled && (0, _stylitas.css)(_templateObject4(), _stylitas.utilities.palette.color(theme, 'warning'));
};

exports.helperTextWarning = helperTextWarning;

var helperTextDanger = function helperTextDanger(_ref5) {
  var theme = _ref5.theme,
      variant = _ref5.variant,
      disabled = _ref5.disabled;
  return variant === 'danger' && !disabled && (0, _stylitas.css)(_templateObject5(), _stylitas.utilities.palette.color(theme, 'danger'));
};

exports.helperTextDanger = helperTextDanger;

var inputVariants = function inputVariants(_ref6) {
  var relatedInputType = _ref6.relatedInputType;

  switch (relatedInputType) {
    case 'textarea':
      return (0, _stylitas.css)(_templateObject6());

    default:
      return (0, _stylitas.css)(_templateObject7());
  }
};

exports.inputVariants = inputVariants;